/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import styles from "ui/feature/piece-play/common/piece-renderer/PieceRendererViewOriginalImageData.module.scss"

interface Props {
    image_url: string;
}

const PieceRendererViewOriginalImageData: React.FC<Props> = ({image_url}) => {
    console.log("have image url", image_url);
    return (
        <div>
            <img className={styles.img} alt={"Original Note"} src={image_url}/>
        </div>
    );
}

export default PieceRendererViewOriginalImageData;